import { BigNumber } from '@0x/utils'
import { Asset } from 'app-lib/assetUtils'

export enum DEX {
  UNISWAPV3 = 'UNISWAPV3',
  SUSHI = 'SUSHI',
  AUTO = 'AUTO',
}

export interface IUniRoute {
  topN: number
  topNDirectSwaps: number
  topNSecondHop: number
  topNTokenInOut: number
  topNWithBaseToken: number
  topNWithEachBaseToken: number
}

export type DexDataPayload = {
  srcToken: Asset
  destToken: Asset
  amountUsed: BigNumber
  direction: TradeType
  amountsInMax?: BigNumber
}

export enum TradeType {
  EXACT_INPUT,
  EXACT_OUTPUT,
}
